export default function Step1() {
    return (
        <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M33.582 10.833H36.832C39.2252 10.833 41.1653 12.7731 41.1653 15.1663V41.1663C41.1653 43.5596 39.2252 45.4996 36.832 45.4996H15.1653C12.7721 45.4996 10.832 43.5596 10.832 41.1663V15.1663C10.832 12.7731 12.7721 10.833 15.1653 10.833H18.4153"
                stroke="#7293F7"
                strokeWidth="2.5"
            />
            <path d="M19.5 29.6491L24.5175 34.6667L33.1842 26" stroke="#7293F7" strokeWidth="2.5" />
            <path
                d="M19.4978 7.54004H32.4978C33.12 7.54004 33.6244 8.04446 33.6244 8.66671V13C33.6244 13.6222 33.12 14.1267 32.4978 14.1267H19.4978C18.8755 14.1267 18.3711 13.6222 18.3711 13V8.66671C18.3711 8.04447 18.8755 7.54004 19.4978 7.54004Z"
                stroke="#7293F7"
                strokeWidth="2.08"
            />
        </svg>
    );
}
